var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeekAutocomplete, PeekInput, PeekStack, PeekTooltip, PeekTypography, } from "@piiqtechnologies/ui-components";
import { useDebounce, useError, useProspects } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { Info as InfoIcon } from "@piiqtechnologies/svg-icons";
import CreateProspectDialog from "./create-prospect/CreateProspectDialog";
import messages from "./messages.i18n";
export const ProspectSelector = (_a) => {
    var { field, form, disabled, required, communityId } = _a, props = __rest(_a, ["field", "form", "disabled", "required", "communityId"]);
    const [getProspects, prospectsResp, prospectsInProgress, prospectsError] = useProspects();
    const [openCreateProspectDialog, setOpenCreateProspectDialog] = useState(false);
    const { setError } = useError();
    const [email, setEmail] = useState();
    const debouncedSearchKey = useDebounce(email, 700);
    const intl = useIntl();
    const prospects = useMemo(() => {
        var _a;
        const prospectList = [
            {
                firstName: "",
                lastName: "",
                _id: "",
                email: "",
                phone: "",
            },
            ...((((_a = prospectsResp === null || prospectsResp === void 0 ? void 0 : prospectsResp.data) === null || _a === void 0 ? void 0 : _a.length) && (prospectsResp === null || prospectsResp === void 0 ? void 0 : prospectsResp.data)) || []),
        ];
        return prospectList;
    }, [prospectsResp === null || prospectsResp === void 0 ? void 0 : prospectsResp.data]);
    const toggleCreateProspectDialog = () => {
        setOpenCreateProspectDialog((prevDialogOpenState) => !prevDialogOpenState);
    };
    useEffect(() => {
        ((debouncedSearchKey === null || debouncedSearchKey === void 0 ? void 0 : debouncedSearchKey.length) >= 3 || !debouncedSearchKey) &&
            getProspects({
                offset: 0,
                limit: 50,
                search: !debouncedSearchKey ? debouncedSearchKey : undefined,
            });
    }, [debouncedSearchKey]);
    useEffect(() => {
        if (prospectsError === null || prospectsError === void 0 ? void 0 : prospectsError.message) {
            setError(prospectsError === null || prospectsError === void 0 ? void 0 : prospectsError.message);
            handleProspectSelection(null, null);
        }
    }, [prospectsError]);
    const handleProspectSelection = (_event, prospect) => {
        //@ts-ignore
        form.setFieldValue(field.name, prospect);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekAutocomplete, { freeSolo: false, clearIcon: null, loading: prospectsInProgress, options: prospects, value: field.value, disabled: disabled, onChange: handleProspectSelection, onAddNew: toggleCreateProspectDialog, addNewLabel: intl.formatMessage(messages.addNewProspect), sx: { ".MuiAutocomplete-input": { pl: "4px !important" } }, isOptionEqualToValue: (option, value) => option._id === value._id, getOptionLabel: ({ email, firstName, lastName }) => email && `${email} - ${firstName} ${lastName}`, popupIcon: React.createElement(PeekTooltip, { placement: "top-start", title: React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(messages.prospectTrackingGuide)) },
                React.createElement(PeekStack, { alignItems: "center" },
                    React.createElement(PeekTypography, { variant: "h3", color: "primary", lineHeight: 1.5 },
                        React.createElement(InfoIcon, null)))), renderInput: (params) => (React.createElement(PeekInput, Object.assign({ field: Object.assign(Object.assign({}, field), { value: email, onChange: (e) => setEmail(e.target.value) }), error: (debouncedSearchKey === null || debouncedSearchKey === void 0 ? void 0 : debouncedSearchKey.length) < 3, helperText: (debouncedSearchKey === null || debouncedSearchKey === void 0 ? void 0 : debouncedSearchKey.length) < 3 && intl.formatMessage(messages.searchLengthError), form: form }, params, props, { InputLabelProps: { required: required, disabled }, InputProps: Object.assign({}, params.InputProps) }))) }),
        React.createElement(CreateProspectDialog, { onClose: toggleCreateProspectDialog, open: openCreateProspectDialog, communityId: communityId })));
};
export default ProspectSelector;
